<template>
    <div class="view">
        <div class="header" id="header_first">
            <div class="hos-name">
                <div class="hospital_name" :class="isCollapse?'short-name':''">
                    <div class="hos-img">
                        <img v-if="hospitalMsg.url" :src="hospitalMsg.url" alt="">
                        <img v-else src="@/assets/img/hos_t.png" alt="">
                    </div>
                    <div class="hos-name-title" id="hos_title_box" v-if="!isCollapse">
                        <div id="hos_title_text">{{hospitalMsg.name}}</div>
                    </div>
                </div>
                <div class="tab_box">
                    <div class="title">
                        <span class="iconfont">&#xe8ff;</span>
                        <span>{{componentTitle}}</span>
                    </div>
                    <div v-if="tabList && tabList.length>0" class="tab_router">
                        <div class="tab_btn"
                             :class="tabId === item.path ? 'actived_tab' : ''"
                             v-for="(item, index) in tabList"
                             @click="changeTopTab(item)"
                             v-if="sideTabShow(item)"
                             :key="index">
                            {{item.name}}
                        </div>
                    </div>
                </div>

                <div class="message_text" v-if="show_message_text">{{show_message_text}}</div>
            </div>


            <div class="btn-box">
                <!---->
                <el-popover
                        width="5 00"
                        placement="bottom"
                        title="未读消息"
                        v-if="msgTotal > 0"
                        trigger="click">
                    <div class="msg_table">
                        <div class="show_msg">
                            <div v-for="(item, index) in lessMsgData"
                                 :key="index"
                                 class="table_item">
                                <div class="text">{{item.content}}</div>
                                <div class="date">{{item.create_time}}</div>
                            </div>
                        </div>
                        <div class="bottom_btn" @click="changeComponent(msgView)">
                            <!--@click="changeComponent('msgView')"-->
                            查看更多...
                        </div>
                    </div>
                    <el-badge :value="msgTotal" slot="reference" class="item">
                        <div class="msg_box">
                            <span class="icon iconfont icon-24gl-bell"></span>
                        </div>
                    </el-badge>
                </el-popover>
                <div class="msg_box" v-else @click="changeComponent(msgView)">
                    <span class="icon iconfont icon-24gl-bell"></span>
                </div>

                <el-popover
                        placement="bottom"
                        width="180"
                        trigger="hover"
                        v-model="visible">
                    <div class="user_popover">
                        <div class="user_box">
                            <div class="user_img">
                                <img v-if="user.avatar" :src="userImgUrl(user.avatar)" alt="">
                                <img v-else src="@/assets/img/doctor.png" alt="">
                            </div>
                            <div class="user_msg">
                                <div class="user_name">{{user.name}}</div>
                                <div class="user_name">{{user.phone}}</div>
                            </div>
                        </div>
                        <div class="edit_btn">
                            <div class="btn">
                                <el-button size="mini" @click="openEditImg">修改头像</el-button>
                            </div>
                            <div class="btn">
                                <el-button size="mini" @click="openEditPhone">修改手机</el-button>
                            </div>
                            <div class="btn">
                                <el-button size="mini" @click="openEditPass">修改密码</el-button>
                            </div>
                            <div class="btn" v-if="user.is_subscribed == 1">
                                <el-button size="mini" @click="openWXDialog('first')">绑定微信</el-button>
                            </div>
                            <div class="btn" v-if="user.is_subscribed == 2">
                                <el-button size="mini" @click="openWXDialog()">已绑定</el-button>
                            </div>
                        </div>
                        <div class="login_out_btn">
                            <el-button type="primary" size="mini" @click="outLogin">退出</el-button>
                        </div>
                    </div>
                    <div class="user" slot="reference">
                        <div class="user_img">
                            <img v-if="user.avatar" :src="userImgUrl(user.avatar)" alt="">
                            <img v-else src="@/assets/img/doctor.png" alt="">
                        </div>
                        <div class="user_name">{{user.name}}</div>
                    </div>
                </el-popover>
            </div>
        </div>

        <el-dialog :title="wx_dialog_title"
                   :visible.sync="dialogVisible_wx"
                   :modal-append-to-body="false"
                   :close-on-click-modal="false"
                   :close-on-press-escape="false"
                   top="8vh"
                   width="500px">
            <div class="wx_box">
                <div class="wx_header">
                    {{wx_header_text}}
                </div>
                <div class="qrcode_box">
                    <div class="qrcode_title">
                        扫码进入"舒心可达患者关爱项目公众号"
                    </div>
                    <div class="qrcode">
                        <el-image :src="qrcode_url"></el-image>
                    </div>
                </div>
            </div>
        </el-dialog>
        <el-dialog title="修改密码"
                   :visible.sync="passwordVisible"
                   :modal-append-to-body="false"
                   :close-on-click-modal="false"
                   :close-on-press-escape="false"
                   top="8vh"
                   width="450px">
            <el-form :model="passwordForm"
                     :rules="passRules"
                     label-width="120px"
                     ref="passwordForm"
            >
                <el-form-item label="旧密码：" prop="old_password">
                    <el-input v-model="passwordForm.old_password"
                              placeholder="请输入旧密码"
                              class="width_all"
                              show-password
                    ></el-input>
                </el-form-item>
                <el-form-item label="新密码：" prop="new_password">
                    <el-input v-model="passwordForm.new_password"
                              placeholder="请输入新密码"
                              class="width_all"
                              show-password
                    ></el-input>
                </el-form-item>
                <el-form-item label="确认新密码：" prop="again_password">
                    <el-input v-model="passwordForm.again_password"
                              placeholder="请确认新密码"
                              class="width_all"
                              show-password
                    ></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="passwordVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitEditPass">确 定</el-button>
            </div>
        </el-dialog>

        <el-container class="main">
            <el-aside class="aside_box" id="left_aside_box" :class="isCollapse ? '' : 'wide_aside'">
                <div class="header_box" @click="changeIsCollapse">
                    <span v-if="!isCollapse">概览</span>
                    <i v-if="isCollapse" class="el-icon-s-unfold"></i>
                    <i v-if="!isCollapse" class="el-icon-s-fold"></i>
                </div>
                <el-menu class="el-menu-vertical-demo"
                         text-color="#DCDFE6"
                         active-text-color="#fff"
                         :default-active="activeIndex"
                         :default-openeds="openeds"
                         @open="setOpeneds"
                         :unique-opened="true"
                         :collapse="isCollapse">
                    <template v-for="(item,index) in showSide">
                        <el-menu-item :index="item.index"
                                      @click="changeComponent(item)"
                                      v-if="sideTabShow(item) && !item.children">
                            <i v-if="item.icon" style="padding-right: 5px" :class="item.icon"></i>
                            <span slot="title">{{item.name}}</span>
                        </el-menu-item>

                        <el-submenu :index="item.index"
                                    v-if="sideTabShow(item) && item.children">
                            <template slot="title">
                                <i v-if="item.icon" :class="item.icon" style="padding-right: 5px"></i>
                                <span slot="title">{{item.name}}</span>
                            </template>

                            <el-menu-item-group>
                                <el-menu-item v-for="(items, indexs) in item.children"
                                              :index="items.index"
                                              @click="changeComponent(items)"
                                              v-if="sideTabShow(items)"
                                              :key="indexs">
                                    {{items.name}}
                                </el-menu-item>
                            </el-menu-item-group>
                        </el-submenu>
                    </template>
                </el-menu>
            </el-aside>

            <el-main class="main_box">
                <router-view></router-view>
            </el-main>
        </el-container>
    </div>
</template>

<script>
    import {ssGet, ssSet, lcSet, lcGet, ssRemove, lcRemove, clone, lcGetWithAge} from "../global/utils";
    import side from "@/global/homeSide"
    import {getImageUrl} from "../api/index"
    import {mapState, mapMutations} from 'vuex'
    import config from "../global/config"

    export default {
        name: 'Home',
        data() {
            const checkPass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请再次输入密码'));
                } else if (value !== this.passwordForm.new_password) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            };
            return {
                app_env: '',

                isCollapse: false,
                activeIndex: '',
                showSide: side,
                main_url: '',
                show_main: 'iframe',

                visible: false,
                openeds: [],

                msgTotal: 3,
                lessMsgData: [],
                msgView: {
                    name: '我的消息',
                    path: 'readMsgView',
                    index: '99-99',
                    icon: '',
                    decide: [],
                },
                getMsgInterval: null,

                user: {},

                wx_dialog_title: '',
                dialogVisible_wx: false,
                wx_header_text: '',

                usermsg: {},
                titleSize: [
                    '19px',
                    '17px',
                    '15px',
                    '14px',
                    '12px',
                    '12px',
                    '12px',
                    '12px',
                    '12px',
                    '12px',
                    '12px',
                    '12px',
                    '12px',
                ],

                hospitalList: [
                    {name: '上海瑞金医院'},
                    {name: '上海仁济医院'},
                ],
                select_hos: '上海瑞金医院',

                tabId: '',
                tabList: [],
                componentTitle: '',

                // 修改密码
                passwordForm: {},
                passwordVisible: false,
                passRules: {
                    old_password: [{required: true, message: '请输入旧密码', trigger: 'blur'}],
                    new_password: [{required: true, message: '请输入新密码', trigger: 'blur'}],
                    again_password: [{required: true, validator: checkPass, trigger: 'blur'}],
                }
            }
        },
        computed: {
            ...mapState('comInformationData', {
                hospitalMsg: 'hospitalMsg',
                authority: 'authority'
            }),
            user_id() {
                if (localStorage.getItem('user')) {
                    return JSON.parse(localStorage.getItem('user')).user_id
                }
                else {
                    return null
                }
            },
            old_user_name() {
                let name = JSON.parse(lcGet('user')).user_login_name;
                return name
            }
            ,

            qrcode_url() {
                return config.BASE_URL + '/wxmini_static/img/qrcode0211.jpg'
            }
            ,

            show_message_text() {
                let text = this.app_env == 'dev' ? '该版本为开发环境'
                    : this.app_env == 'test' ? '该版本为135测试环境'
                        : this.app_env == 'prev' ? '该版本为体验测试环境'
                            : this.app_env == 'prod' ? ''
                                : '';
                return text
            }
            ,
        },
        watch: {}
        ,
        filters: {}
        ,
        created() {
            // this.user = JSON.parse(lcGet('user')).user || {};
        }
        ,
        mounted() {
            if (lcGetWithAge('token')) {
                this.getUserInfo()
            } else {
                this.$router.push('login')
            }

            this.$eventBus.$on('getClassifyList', this.getClassifyList());
        }
        ,
        beforeDestroy() {
            clearInterval(this.getMsgInterval)
        }
        ,
        methods: {
            ...
                mapMutations('comInformationData', {
                    setAllIllData: 'setAllIllData',
                    setIllUserData: 'setIllUserData',
                    setComponentID: 'setComponentID',
                    setPower: 'setPower',
                    setConfig: 'setConfig',
                    setLearnClassifyList: 'setLearnClassifyList',
                    setCityList: 'setCityList',
                }),
            getUserInfo() {
                this.httpGet('/user/get_user_by_token').then(res => {
                    lcSet("user", JSON.stringify(res.data));
                    this.user = JSON.parse(lcGet('user')).user || {};

                    this.fontSizeAuto();
                    this.getIllData();
                    this.getClassifyList();
                    this.getComConfig();
                    this.getPower();
                    this.getCity();
                    this.setGetMsgInter();
                })
            }
            ,

            getComConfig() {
                // 获取公共配置
                this.httpGet('/conf').then(res => {
                    this.setConfig(res.data);

                    this.app_env = res.data.app.env
                })
            }
            ,
            getCity() {
                // 获取省市（搜索医院用）
                this.httpGet('/hospital/province_city').then(res => {
                    this.setCityList(res.data)
                })
            }
            ,
            getPower() {
                // 获取权限
                this.httpGet('/user/admin/authority_list').then(res => {
                    let data = res.data;
                    data.push("hash-tool");
                    this.setPower(data);

                    let first = true;
                    let power = data.join(',');
                    this.showSide.forEach(v => {
                        if (v.children) {
                            v.children.forEach(e => {
                                if (first) {
                                    e.decide.forEach(d => {
                                        if (power.indexOf(d) > -1) {
                                            this.changeComponent(e);
                                            first = false
                                        }
                                    })
                                    // if(e.decide.find(d => d == 'visit-audit')){
                                    //     this.changeComponent(e);
                                    //     first = false
                                    // }
                                }
                            })
                        } else {
                            if (first) {
                                v.decide.forEach(d => {
                                    if (power.indexOf(d) > -1) {
                                        this.changeComponent(v);
                                        first = false
                                    }
                                })
                            }
                        }
                    });
                });
            }
            ,
            getClassifyList() {
                // 获取图文分类
                let params = {
                    dict_name: '图文分类',
                };
                this.httpGet('/cdict/list', params).then(res => {
                    this.setLearnClassifyList(res.data);
                });
            }
            ,
            getIllData() {
                // 获取病种
                this.httpGet('/tumour').then(res => {
                    this.setAllIllData(res.data)
                })
            }
            ,

            setGetMsgInter() {
                this.getReadMsgData();
                this.getMsgInterval = setInterval(() => {
                    this.getReadMsgData()
                }, 60 * 1000)
            }
            ,
            getReadMsgData() {
                // 获取未读消息列表
                let params = {
                    // is_read 1 否 2 是 不传是全部
                    is_read: 1
                };
                this.httpGet('/message/list', params).then(res => {
                    this.lessMsgData = res.data.data_list.filter((v, index) => index < 10);
                    this.msgTotal = res.data.total
                })
            }
            ,

            userImgUrl(url) {
                return getImageUrl(url)
            }
            ,

            setOpeneds(index) {
                this.openeds = [];
                this.openeds.push(index)
            }
            ,
            /**
             * 开始
             * */
            fontSizeAuto() {
                if (this.isCollapse) return;
                let innerB = document.getElementById('hos_title_text');
                let innerW = innerB.innerHTML.length;
                // console.log(innerB, innerW, 'title_fontsize');
                if (innerW > 6) {
                    innerB.style.fontSize = this.titleSize[(innerW - 7)]
                } else {
                    innerB.style.fontSize = '20px'
                }
            }
            ,
            // 左侧导航栏权限验证
            sideTabShow(item) {
                let list = item.decide;
                return this.showTab(list)
            }
            ,
            showTab(list) {
                if (list.length === 0) return true;
                let tab = false;
                this.authority.forEach(v => {
                    list.forEach(e => {
                        if (v.indexOf(e) > -1) {
                            tab = true
                        }
                    })
                });
                return tab;
            }
            ,

            /**
             * 修改头像、密码
             * */
            openEditPass() {
                this.passwordForm = {
                    old_password: '',
                    new_password: '',
                    again_password: ''
                };
                this.passwordVisible = true;
                this.$nextTick(() => {
                    this.$refs.passwordForm.resetFields()
                })
            }
            ,
            submitEditPass() {
                this.$refs.passwordForm.validate(valid => {
                    if (valid) {
                        let params = {
                            ...this.passwordForm
                        };
                        this.httpPost('/user/password/update', params).then(res => {
                            this.$message.success('密码修改成功');
                            this.passwordVisible = false;
                        }).catch(err => {
                            this.$message.error(err.msg)
                        })
                    }
                })
            }
            ,
            openEditImg() {

            }
            ,
            openEditPhone() {

            }
            ,
            openWXDialog(val) {
                let code = '';
                this.httpGet('/user/bind_wx_code').then(res => {
                    code = res.data.code;
                    if (val && val === 'first') {
                        this.wx_dialog_title = '绑定微信';
                        this.wx_header_text = `绑定公众号接收消息提醒，请在"舒心可达患者关爱项目公众号"发送消息: ${code}`
                    } else {
                        this.wx_dialog_title = '更换绑定微信';
                        this.wx_header_text = `您已绑定公众号，更换接收消息微信号请在"舒心可达患者关爱项目公众号"发送消息: ${code}`
                    }
                    this.dialogVisible_wx = true
                });
            }
            ,

            /**
             * 退出登录
             * */
            outLogin() {
                this.$message({
                    message: '已退出当前账户！',
                    type: 'success'
                });
                this.$router.push("Login");
                setTimeout(() => {
                    this.removerLoginOut();
                }, 0)
            }
            ,
            removerLoginOut() {
                lcRemove('token');
                lcRemove('user');
            }
            ,

            // 路由跳转
            changeComponent(item) {
                console.log(item, '351---router---');
                const that = this;
                if (item.index) {
                    this.activeIndex = item.index;
                    this.componentTitle = item.name;
                    this.tabList = [];
                    this.tabId = '';
                }
                if (item.path) {
                    // this.show_main = 'component';
                    this.$router.push(item.path);
                    if (item.tab_list && item.tab_list.length > 0) {
                        this.tabList = item.tab_list.filter(v => this.sideTabShow(v));

                        this.changeTopTab(this.tabList[0])
                    }
                }
            }
            ,
            changeTopTab(item) {
                // 头部tab跳转
                this.setComponentID('');
                this.$nextTick(() => {
                    this.setComponentID(item.path);
                    this.tabId = item.path;
                })
            }
            ,

            changeIsCollapse() {
                return;
                this.isCollapse = !this.isCollapse;
                lcSet('isCollapse', this.isCollapse);
                if (!this.isCollapse) {
                    this.$nextTick(() => {
                        this.fontSizeAuto()
                    })
                }
            }
            ,
        }
    }
</script>
<style scoped lang="scss">
    .msg_table {
        .show_msg {
            max-height: 500px;
            overflow: hidden;
            overflow-y: auto;
            .table_item {
                line-height: 30px;
                border-bottom: 1px solid #cccccc;
                padding-left: 15px;
                display: flex;

                &:first-child {
                    border-top: 1px solid #cccccc;
                }
                &:hover {
                    background: #ecf5ff;
                }
                .text {
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    flex: 1;
                }
                .date {
                    flex: 0 0 150px;
                    text-align: center;
                    padding-left: 5px;
                    box-sizing: border-box;
                }
            }
        }

        .bottom_btn {
            line-height: 40px;
            text-align: center;
            cursor: pointer;
            &:hover {
                background: #c6e2ff;
            }
        }
    }

    .user_popover {
        text-align: left;
        margin: 0;
        .user_box {
            display: flex;
            height: 50px;
            .user_img {
                flex: 0 0 50px;
                padding-right: 10px;
                img {
                    width: 50px;
                    height: 50px;
                    border-radius: 50%;
                    overflow: hidden;
                }
            }
            .user_msg {
                font-size: .75rem;
            }
        }
        .edit_btn {
            display: flex;
            flex-wrap: wrap;
            border-top: 1px solid #ccc;
            border-bottom: 1px solid #ccc;
            margin: 5px 0;
            .btn {
                flex: 0 0 80px;
                padding: 5px;
                font-size: .875rem;
                .el-button {
                    width: 100%;
                }
            }
        }
        .login_out_btn {
            width: 100%;
            text-align: right;
            font-size: .875rem;
        }
    }

    .view {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        height: 100%;
        .header {
            width: 100%;
            height: 50px;
            line-height: 50px;
            display: flex;
            justify-content: space-between;
            background: #fff;
            user-select: none;
            .hos-name {
                flex: 0 0 205px;
                display: flex;
                box-sizing: border-box;
                /*width: calc(100% - 250px);*/
                .hospital_name {
                    flex: 0 0 189px;
                    border-right: 1px solid #c6e2ff;
                    font-weight: 600;
                    font-size: 20px;
                    padding-left: 15px;
                    display: flex;
                    .hos-img {
                        img {
                            /*height: 32px;*/
                            width: 32px;
                            padding: 9px 10px 0 0;
                        }
                    }
                    .hos-name-title {
                        width: 140px;
                        .hos_title_text {
                        }
                    }
                }
                .short-name {
                    flex: 0 0 48px;
                    .hos-img {
                        img {
                            height: 32px;
                            width: 32px;
                            padding: 7px 5px 0 0;
                        }
                    }
                    .hos-name-title {
                        display: none;
                    }
                }
                .tab_box {
                    display: flex;
                    width: 100%;
                    .title {
                        font-size: .875rem;
                        padding: 0 20px;
                        min-width: 100px;
                        white-space: nowrap;
                        .iconfont {
                            color: #409EFF;
                            padding: 0 5px;
                        }
                    }
                    .tab_router {
                        flex: 1;
                        display: flex;
                        .tab_btn {
                            white-space: nowrap;
                            padding: 0 20px;
                            box-sizing: border-box;
                            border-bottom: 2px solid #fff;
                            font-size: .875rem;
                        }
                        .actived_tab {
                            border-bottom: 2px solid #409eff;
                        }
                    }
                }

                .message_text {
                    color: red;
                    width: 500px;
                    font-size: 20px;
                }
            }
            .middle_box {
                flex: 1;
                padding: 0 20px;

                .middle_title {
                    height: 40px;
                    line-height: 40px;
                    margin-top: 10px;
                    .icon {
                        font-size: 1.125rem;
                        padding-right: 20px;
                    }
                    .select_hos_span {
                        cursor: pointer;
                    }
                }
            }
            .btn-box {
                /*flex: 0 0 250px;*/
                display: flex;

                .msg_box {
                    display: flex;
                    padding: 0 15px;
                    cursor: pointer;
                    font-size: 0.875rem;
                    .icon {
                        font-size: 1.125rem;
                    }
                    &:hover {
                        background: #f2f2f4;
                    }

                }
                .user {
                    display: flex;
                    cursor: pointer;
                    margin-left: 40px;
                    .user_img {
                        height: 50px;
                        position: relative;
                        img {
                            width: 40px;
                            height: 40px;
                            border-radius: 50%;
                            background: #C7E0FB;
                            position: absolute;
                            top: 50%;
                            transform: translateY(-50%);
                        }
                    }
                    .user_name {
                        padding: 0 20px 0 50px;
                        font-size: 0.875rem;
                    }
                }
            }
        }
        .main {
            width: 100%;
            height: calc(100% - 60px);
            background: #eee;
            .aside_box {
                background: #409eff;
                width: auto !important;
                user-select: none;
                font-size: 0.875rem;
                .header_box {
                    height: 20px;
                    line-height: 20px;
                    background: #409eff;
                    border-bottom: 1px solid rgba(255, 255, 255, .1);
                    display: flex;
                    justify-content: space-between;
                    font-size: 16px;
                    font-weight: 600;
                    padding: 15px 20px;
                    color: #fff;
                    i {
                        font-size: 23px;
                    }
                }
            }
            .wide_aside {
                min-width: 205px;
            }
            .main_box {
                padding: 5px;
                background: #f1f4f5;
                box-sizing: border-box;
                overflow: hidden;
            }
        }

    }

    .wx_box {
        font-size: 1rem;
        .wx_header {
            line-height: 30px;
            text-indent: 2em;
        }
        .qrcode_box {
            padding-top: 10px;
            .qrcode_title {
                text-align: center;
            }
            .qrcode {
                text-align: center;
            }
        }
    }
</style>
<style lang="scss">
    .btn-box {
        sup.el-badge__content.el-badge__content--undefined.is-fixed {
            top: 15px;
            right: 25px;
        }
    }
</style>
